import {
    format
} from '../../../../assets/helpers'

export class Coberturas {


    static getState() {
        const cobs = document.querySelectorAll("#cobs_container");
        const cobsData = [];
        const error = [];

        if (cobs.length == 0) {
            return {
                isValid: true,
                cobs: []
            }
        }

        cobs.forEach(cob => {
            const switchData = cob.querySelector(".custom__switch");
            const input = cob.querySelector("[type='text']");
            const select = cob.querySelector("select");
            const check = cob.querySelector("[type='checkbox']");

            const nombre = switchData.getAttribute("data-nombre");
            const active = check.checked ? "V" : "F";

            let clave = switchData.getAttribute("data-clave");
            let idcobertura = switchData.getAttribute("data-idcobertura");
            let desclimax = switchData.getAttribute("data-desclimax");
            let sa_cobertura = switchData.getAttribute("data-saCob");
            let monto = 0;

            // Caso 1: Cobertura inactiva

            // Caso 2: Cobertura activa
            if (active == "V") {
                if (select) {

                    const optionSelected = select.selectedOptions[0];

                    if (optionSelected.value == "") {
                        error.push(`Selecciona una opción válida para ${nombre}`);
                    }

                    desclimax = optionSelected.getAttribute("data-desclimax");
                    sa_cobertura = optionSelected.getAttribute("data-sa_decobertura");
                    idcobertura = optionSelected.getAttribute("data-idCobertura");
                    clave = optionSelected.value
                }

                if (input) {
                    monto = input.value;
                }

                if (desclimax == "NO IMPRIMIR" && sa_cobertura == "BASICA") {
                    const amount = document.querySelector("[name='sumaAseg']").value;
                    monto = amount;
                }

            }

            cobsData.push({
                nombre,
                clave,
                idcobertura,
                desclimax,
                sa_cobertura,
                monto,
                active,
                hijas: select ? true : false
            });
        });

        if (error.length > 0) {
            return {
                isValid: false,
                error,
                cobs: cobsData
            }
        }

        return {
            isValid: true,
            cobs: cobsData
        }
    }

    static getInitialState() {
        return this.getState().cobs;
    }

    static compare(initialState) {
        const currentState = this.getState().cobs;
        let cobsToUpdate = [];
        const error = [];
        const sumaAseg = format.number(document.querySelector("[name='sumaAseg']").value);

        if (initialState.length > 0) {
            initialState.forEach(initial => {
                let currentCob = currentState.filter(item => item.nombre == initial.nombre);
    
                if (currentCob.length > 0) {
    
                    const {
                        active,
                        clave,
                        monto,
                        hijas,
                        nombre
                    } = currentCob[0];
    
    
                    // Revisamos si cambió monto, clave o active
                    if (clave != initial.clave || monto != initial.monto || active != initial.active) {
                        if (active == "F") {
                            const newState = {
                                ...initial
                            };
                            newState.active = "F";
                            newState.monto = 0;
                            cobsToUpdate.push(newState)
                        } else {
                            // Si esta activo y tiene hijas, da de baja primero lo anterior
                            if (hijas && initial.clave != "NoAplica") {
                                const newState = {
                                    ...initial
                                };
                                newState.active = "F";
                                cobsToUpdate.push(newState)
                            }
    
                            cobsToUpdate.push({
                                ...currentCob[0]
                            })
                        }
                    }
                }
            });
        } else {
            cobsToUpdate = currentState.filter(current => current.active == "V");
        }



        // Valida que todas estén correctamente seleccionadas
        if (cobsToUpdate.length > 0) {
            cobsToUpdate.forEach(cob => {
                if (cob.clave == "NoAplica" || !cob.clave && cob.active == "V") {
                    error.push(`Selecciona una opción válida para ${cob.nombre}`)
                }
                if (cob.active == "V" && cob.monto == 0) {
                    error.push(`Monto inválido para ${cob.nombre}`);
                }
                if (cob.active == "V" && format.number(cob.monto) > sumaAseg) {
                    error.push(`El monto de ${cob.nombre} no puede ser mayor al de la suma asegurada.`)
                }
            });
        }

        if (error.length > 0) {
            let errorString = `<ul class="p-0" style="list-style: none">`;
            error.forEach(err => {
                errorString += `<li><i class="fas fa-times text-danger"></i> ${err}</li>`
            })
            errorString += `</ul>`

            return {
                isValid: false,
                error,
                errorString
            }
        }
        return {
            isValid: true,
            cobsToUpdate
        };
    }

    // Activa las coberturas guardadas previamente
    static async setSaved(coberturas, switchComponentPromise) {
        await switchComponentPromise;
        coberturas.forEach(cobertura => {
            const switchContainer = document.querySelector(`.${cobertura.NOM_COBERTURA}`).parentElement;
            const check = switchContainer.querySelector("[type='checkbox']");
            const input = switchContainer.querySelector("[type='text']");
            const hija = cobertura.CoberturasHijas.length > 0 ? cobertura.CoberturasHijas[0] : null;
            let monto = 0;
            check.checked = true;

            if (hija) {
                const idCob = hija.ID_COBERTURA;
                const select = switchContainer.querySelector("select");
                const optionSelected = select.querySelector(`[data-idcobertura='${idCob}']`);
                select.classList.remove("d-none");
                select.value = optionSelected.value;
                monto = hija.SA_AMPARADA
            }

            if (input) {
                input.classList.remove("d-none");
                input.value = hija ? format.money(hija.SA_AMPARADA) : format.money(cobertura.SA_AMPARADA);
            }
        });
    }

    static getActives(initialState, mainCob) {
        const {
            SA_AMPARADA,
            NOM_COBERTURA,
            ID_COBERTURA
        } = mainCob;
        const initialActiveState = initialState.filter(initial => initial.active == "V");
        const actives = [{
            active: "V",
            clave: "MTE",
            monto: SA_AMPARADA,
            nombre: NOM_COBERTURA,
            idcobertura: ID_COBERTURA
        }, ...initialActiveState];
        return initialActiveState;
    }
}